import routes from 'js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils/kept_alive_post';

type UrlFragmentPayload = {
  full_hash: string;
  is_text_fragment: boolean;
  hit_id: number | null;
};

const MAX_HASH_LENGTH = 5000;

const getFullHash = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  let fullHash = '';
  try {
    const navEntry = window.performance?.getEntriesByType('navigation')?.[0];
    if (navEntry?.name) {
      fullHash = new URL(navEntry.name).hash;
    }
  } catch (_error) {
    fullHash = '';
  }

  if (!fullHash) {
    fullHash = window.location.hash || '';
  }

  if (!fullHash || fullHash === '#') {
    return null;
  }

  if (fullHash.length > MAX_HASH_LENGTH) {
    return fullHash.slice(0, MAX_HASH_LENGTH);
  }

  return fullHash;
};

const sleep = (delayMs: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });

const waitForHitId = async (): Promise<number | null> => {
  const maxAttempts = 10;
  const delayMs = 250;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const hitId = window.Aedu?.hit_data?.id ?? null;
    if (hitId) return hitId;
    await sleep(delayMs);
  }

  return null;
};

export const trackUrlFragments = (): void => {
  const send = async () => {
    const fullHash = getFullHash();
    if (!fullHash) return;

    const hitId = await waitForHitId();
    if (!hitId) return;

    const payload: UrlFragmentPayload = {
      full_hash: fullHash,
      is_text_fragment: fullHash.includes(':~:text='),
      hit_id: hitId,
    };

    const url = routes.api_v0_record_url_fragment_path({
      subdomain_param: 'api',
    });

    keptAlivePost(url, payload);
  };

  void send();
};
